import AuthOutlet from "@auth-kit/react-router/AuthOutlet";
import { useLocation } from "react-router-dom";
import {
  buildLoginPathWithReturnUrl,
  getSafeReturnUrl,
} from "../../utilities/returnUrlUtility";

interface IPrivateRoutesOutletProps {
  /** Where a logged-out visitor goes from a page that cannot be returned to (e.g. /logout). */
  fallbackPath: string;
}

/**
 * The guard around every private page. A logged-out visitor (an email link opened in a new
 * browser, an expired session) goes to the login page, which brings them back here afterwards.
 * AuthOutlet still does the check, and clears a stale session on the way out.
 */
export const PrivateRoutesOutlet = ({ fallbackPath }: IPrivateRoutesOutletProps) => {
  const location = useLocation();
  const requestedPath = location.pathname + location.search;

  const loginPath = getSafeReturnUrl(requestedPath)
    ? buildLoginPathWithReturnUrl(requestedPath)
    : fallbackPath;

  return <AuthOutlet fallbackPath={loginPath} />;
};
